import { Box, Typography, Button, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { ManagementAdminsStyle as styles } from "./ManagementAdminsStyle";
import AdministratorListTable from "../components/Table/AdministratorListTable";
import { useManagementAdmins } from "../hooks/logic/useManagementAdmins";
import ManagementAdminsDialog from "../components/ManagementAdminsDialog";
import AddAdminDialog from "../components/AddAdminDialog";

const ManagementUsers = () => {
  const {
    inputRef,
    userList,
    selectedRow,
    checkedIds,
    handleCheckChange,
    handleUpdate,
    handleRowClick,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    handleApprove,
    handleCancel,
    handleDelete,
    handleCheckChangeAll,
    handleRegister,
    addAdminDialogOpen,
    setAddAdminDialogOpen,
  } = useManagementAdmins();
  const FOOTER_HEIGHT = 60;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ManagementAdminsDialog
        open={detailDialogOpen}
        onClose={() => {
          // setSelectedParent(null);
          setDetailDialogOpen(false);
        }}
        statusId={4}
        userInfo={selectedRow!}
        onUpdate={handleUpdate}
      />
      <AddAdminDialog
        open={addAdminDialogOpen}
        onClose={() => setAddAdminDialogOpen(false)}
        onResister={handleRegister}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          管理者リスト
        </Typography>
      </Box>
      <Box py={0} px={0}>
        <Box mt={2} ml={2}>
          <Button
            variant="contained"
            sx={styles.orangeButton}
            onClick={() => setAddAdminDialogOpen(true)}
          >
            管理者追加
          </Button>
        </Box>
        <Box mt={2}>
          <AdministratorListTable
            users={userList}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onCheckedChangeAll={handleCheckChangeAll}
            onRowClick={handleRowClick}
            footerHeight={FOOTER_HEIGHT}
          ></AdministratorListTable>
          {/* チェック件数 & ボタンを下部に固定表示 */}
          {checkedIds.size > 0 && (
            <Box
              sx={{
                position: "fixed",
                height: `${FOOTER_HEIGHT}px`,
                bottom: 0,
                right: 0,
                width: "100%",
                bgcolor: "white",
                borderTop: "1px solid #ccc",
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <Box gap={2} sx={{ marginLeft: "240px" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography>全{checkedIds.size}件選択されています</Typography>
                </Box>

                <Box display="flex" gap={2}>
                  <Button variant="outlined" onClick={handleCancel}>
                    キャンセル
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                  >
                    管理者削除
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default ManagementUsers;
